import React from 'react';

import { CenteredDotBounceLoading } from '../NavLoading';
import AuthWrapper from './AuthWrapper';

/** Optionally renders auth wrapper and handles token loading state */
const CustomAuth = ({
  customAuth,
  accessLoaded,
  children,
}: {
  /* Whether the app should be wrapped with OIDC authentication */
  customAuth: boolean;
  /* Whether the portal access token has been loaded (some apps assume this exists on load) */
  accessLoaded: boolean;
  children: JSX.Element | JSX.Element[];
}): JSX.Element =>
  customAuth ? (
    <>{children}</>
  ) : (
    <AuthWrapper>
      {accessLoaded ? children : <CenteredDotBounceLoading />}
    </AuthWrapper>
  );

export default CustomAuth;
